import appConstants from '../../../appConstants';
import { subDays, isSameDay, format, addDays, isWithinInterval } from 'date-fns';

// ============== Date time Utilities ==============
// Note: This file should be only used for date time related operations
// Any new date related functions can be added here

const getWeekdayFromDate = (planDate) => {
  const dateObject = new Date(planDate);
  return dateObject.toLocaleString(appConstants.LOCALES, { weekday: 'long' })?.toLowerCase();
};

const getPastDate = (days, currentDate = new Date()) => {
  return subDays(currentDate, days);
};

const getFutureDate = (days, currentDate = new Date()) => {
  return addDays(currentDate, days);
};

const checkIfSameDay = (day1, day2) => {
  return isSameDay(day1, day2);
};

const formatToISODate = (date) => {
  return format(date, appConstants.APP_DATE_FORMAT);
};

const checkIfDateIsWithinDateRange = (dateToCheck, start, end) => {
  if ((!start && !end) || !dateToCheck) return false;

  const targetDate = new Date(dateToCheck);
  const startDate = start ? new Date(start) : null;
  const endDate = end ? new Date(end) : null;

  if (!startDate) return isSameDay(targetDate, endDate);
  if (!endDate) return isSameDay(targetDate, startDate);

  return isWithinInterval(targetDate, { start: startDate, end: endDate });
};

const toTimestamp = (value) => new Date(value).getTime();

const isValidTimestamp = (value) => {
  if (value === null || value === undefined || value === '') return false;
  return !Number.isNaN(toTimestamp(value));
};

/** Sort comparator — newest timestamp first; invalid/missing timestamps sort last. */
const compareTimestampsDesc = (left, right) => {
  const leftValid = isValidTimestamp(left);
  const rightValid = isValidTimestamp(right);

  if (!leftValid && !rightValid) return 0;
  if (!leftValid) return 1;
  if (!rightValid) return -1;

  return toTimestamp(right) - toTimestamp(left);
};

/** Returns a new array sorted by timestamp, newest first. */
const sortByTimestampDesc = (items, getTimestamp = (item) => item) =>
  [...items].sort((left, right) =>
    compareTimestampsDesc(getTimestamp(left), getTimestamp(right))
  );

export {
  getWeekdayFromDate,
  getPastDate,
  checkIfSameDay,
  getFutureDate,
  formatToISODate,
  checkIfDateIsWithinDateRange,
  compareTimestampsDesc,
  sortByTimestampDesc,
};
